export default "assets/3d6787712fba9d73a641b73359c85d8f.png";